import React from 'react';
import { Carousel, Spin } from 'antd';
import { ImageLoadingObject } from '@common-types';
import { IImage } from '@share/common-types';

import './style.scss';

interface IProps {
  images: IImage[];

  keyValue?: string;

  isNoCoverFit?: boolean;
}

interface IState {
  imagesMap: ImageLoadingObject;
}

const speed = 500;
const slidesToShow = 1;
const slidesToScroll = 1;

export class CarouselImages extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      imagesMap: this.generateImagesMap(),
    };
  }

  generateImagesMap = (): ImageLoadingObject => {
    const map = this.props.images.reduce((res, img, idx) => {
      res[idx] = { img, loading: true };
      // preload
      const pre = new window.Image();
      pre.src = img.url;
      pre.onload  = () => this.onImageLoad(idx);
      pre.onerror = () => this.onImageError(idx);
      return res;
    }, {} as ImageLoadingObject);
  
    return map;
  };

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.images !== this.props.images) {
      this.setState({ imagesMap: this.generateImagesMap() });
    }
  }

  onImageLoad = (index: number): void => {
    this.setState((prevState: IState) => {
      return {
        ...prevState,
        imagesMap: {
          ...prevState.imagesMap,
          [index]: {
            ...prevState.imagesMap[index],
            loading: false,
          },
        },
      };
    });
  };

  onImageError = (index: number): void => {
    this.setState(prev => ({
      imagesMap: {
        ...prev.imagesMap,
        [index]: {
          ...prev.imagesMap[index],
          loading: false,
        },
      },
    }));
  };

  render(): React.ReactNode {
    const propsCarousel = {
      dots: false,
      infinite: true,
      arrows: true,
      speed,
      slidesToShow,
      slidesToScroll,
    };
    const { images, isNoCoverFit, keyValue } = this.props;
    const { imagesMap } = this.state;

    return (
      <Carousel {...propsCarousel} lazyLoad="ondemand">
        {images.map((image: IImage, i: number) => {
          const loading = imagesMap[i]?.loading;
          return (
            <div className="custom-carousel-image" key={i}>
              {loading && (
                <div
                  className="custom-carousel-image__spinner"
                  style={{ height: 'inherit', display: 'flex' }}
                >
                  <Spin />
                </div>
              )}
              <img
                style={{ display: loading ? 'none' : 'block' }}
                key={`carrousel_image${keyValue ? `_${keyValue}` : ''}_${i}`}
                className={`custom-carousel-image__item ${isNoCoverFit ? 'no-cover' : ''}`}
                src={image.url}
                alt={image.description}
                onLoad={() => this.onImageLoad(i)}
                onError={() => this.onImageError(i)}
              />
            </div>
          );
        })}
      </Carousel>
    );
  }
}
